import { useContext } from 'react';
import AppConfig from '../../../../core/AppConfig';
const useAppConfig = () => useContext(AppConfig);
export default useAppConfig;
